import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { CreditContextmenuComponent } from '@app/core/components/contextmenus';
import { DetailCreditPaymentsComponent } from '@app/core/windows'; 
import { ActivatedRoute  } from '@angular/router';


@Component({
  selector: 'credits-crud',
  templateUrl: './credits-crud.component.html',
  providers: [ DatasourceService ]
})
export class CreditsCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(DetailCreditPaymentsComponent, {static: false}) window_detail !: DetailCreditPaymentsComponent;

  //Menu
  @ViewChild(CreditContextmenuComponent, {static: false}) menu_cre !: CreditContextmenuComponent;

  protected menu: string = 'Crédito';

  protected menuIcon: string = 'dollar';
  
  protected label: string = 'Créditos';

  protected name: string = 'Créditos';

  protected table: string = 'credits';

  private sub: any;

  protected status: string = 'ALL';
  
  constructor(private route: ActivatedRoute, protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {
    
    super(authService, service, alertService);
    console.log(this.constructor.name);
    

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'credit_days_left', dir: 'desc'}
    ];

    if(this.status != 'ALL') {

      s.filter = {
        logic: "and",
        filters: [
          {field: 'status_payment', operator: (this.status != 'PAID') ? 'neq': 'eq', value: 'PAGADO'}
        ]
      };

    }

    return s;

  }

  public onCustomExcelExport(e: any, allData: Array<any>): void {

    console.log('onCustomExcelExport');

    const rows = e.workbook.sheets[0].rows;

    let index = 0;
    rows.forEach((row) => {
      if (row.type === 'data') {+
        index++;
        row.cells.forEach((cell, i) => {
          if(typeof cell._column != 'undefined'){
            switch(cell._column){
              case 'Estatus': {
                cell.background = '#' + allData[index-1].status_credit_color;
                cell.color = '#ffffff';
              }; break;
              case 'Costo': {
                cell.format = "$#,##0.00";
              }; break;
            }
          }
        });
      }
    });

  }

  public onCellClick(e: any): void {
      
    console.log(e);
    if (e.type === 'contextmenu') {
      const originalEvent = e.originalEvent;
      originalEvent.preventDefault();
      // this.menu_proy.label = 'Folio consecutivo: ' + e.dataItem.folio_consecutivo;
      this.menu_cre.contextItem = e.dataItem;
      this.menu_cre.menu.show({ left: originalEvent.pageX, top: originalEvent.pageY });
    }

  }

  // public dblClickEvent(e : any) : void {

  //   // console.log('dblClickEvent', e);
  //   if (e.path[1].nodeName === 'TR') {
  //     let index = e.path[1].rowIndex;
  //     let data : DataResult = this.grid.data as DataResult;
  //     this.permissions.edit(data.data[index]);
  //   }

  // }

  public selectMenu({ menu, contextItem }): void {
    
    console.log("selectMenu", menu, contextItem);

    if (menu.url === 'ver') {

      this.window_detail.id = contextItem.id;
      this.window_detail.type = contextItem.type;
      this.window_detail.edit(contextItem)
      // this.window.label = this.label;
      // this.window.table = this.table;
      // this.window.edit(contextItem);

    } 

  }

  ngOnInit() { 
    
    // super.ngOnInit();    

    this.sub = this.route.data.subscribe(v => {
      console.log(v);
      // if(v.menuId == 'VistaSUB->RegistroAll') {
      //   this.canTurn = false;
      //   this.canDelegate = true;
      // }
      // else {
      //   this.canTurn = true;
      //   this.canDelegate = false;
      // }
      this.status = v.status;
      this.name = v.title;

      super.ngOnInit();
      // this.onlyRejected = v.onlyRejected;
      // this.menuId = v.menuId;
      this.breadcrumbItems = this.getBreadcumItems();
    });
  
  }

}